<template>
  <div class="main-container">
    <div class="status-managment-page">
      <div class="status-managment-page__left">
        <main-menu></main-menu>
      </div>
      <div class="status-managment-page__right">
        <Loader v-if="isLogLoadInProgress"></Loader>
        <div class="form">
          <div class="form__row">
            <div class="arenas-table-container">
              <v-table class="paleBlueRows"
                       :data="arenas"
                       :filters="arenasTable.filters">
                <thead slot="head">
                <th>
                  <p>Name</p>
                  <input type="text"
                         class="input-filter"
                         v-model="arenasTable.filters.Name.value"
                         placeholder="Filter by Name"/>
                </th>
                <th>
                  <p>Domain</p>
                  <input type="text"
                         class="input-filter"
                         v-model="arenasTable.filters.Domain.value"
                         placeholder="Filter by Domain"/>
                </th>
                <th>
                  <p>Partner</p>
                  <input type="text"
                         class="input-filter"
                         v-model="arenasTable.filters.Partner.value"
                         placeholder="Filter by Partner"/>
                </th>
                <th>
                  <p>Actions</p>
                </th>
                </thead>
                <tbody slot="body" slot-scope="{displayData}">
                <tr v-for="(row, index) in displayData" :key="index">
                  <td>{{ row.name }}</td>
                  <td>{{ row.domain }}</td>
                  <td>{{ row.partner ? row.partner.name : "" }}</td>
                  <td>
                    <button v-if="$checkRoles(['Administrator'])"
                            @click="changeArenaStatus(row)"
                            :class="[row.status === 0 ? 'ark-btn--success' : 'ark-btn--danger', 'ark-btn ']">
                      <span>{{row.status === 0 ? 'Activate' : 'Disable'}}</span>
                    </button>
                  </td>
                </tr>
                </tbody>
              </v-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../config'
  import Loader from '../Loader/Loader.vue'
  import MainMenu from '../MainMenu/MainMenu.vue'

  export default {
    components: {MainMenu, Loader},
    name: 'ArenaStatusManagementPage',
    props: [],
    data () {
      return {
        arenasTable: {
          filters: {
            Name: {value: '', keys: ['name']},
            Domain: {value: '', keys: ['domain']},
            Partner: {value: '', keys: ['partner ? partner.name : ""']}
          }
        },
        arenas: [],
        isLogLoadInProgress: false
      }
    },
    created: function () {
      this.getArenas()
    },
    methods: {
      changeArenaStatus: function (arena) {
        let messageText = arena.status === 0 ? 'Enable' : 'Disable'
        this.$swal.fire({
          title: 'Are you sure?',
          text: `You want to ${messageText} ${arena.name}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: `Yes, ${messageText} it!`
        }).then((result) => {
          if (result.value) {
            this.isLogLoadInProgress = true
            const formData = new FormData()

            let newStatus = arena.status === 0 ? 1 : 0
            formData.append('options', JSON.stringify({
              'Domain': arena.domain,
              'Status': newStatus
            }))

            this.$http.put(`${config.apiUrl}/arena/change-status`, formData).then(response => {
              arena.status = newStatus
            }, error => {
              console.log(error)
            })
              .then(() => {
                this.isLogLoadInProgress = false
              })
          }
        })
      },
      getArenas: function () {
        this.isLogLoadInProgress = true
        return this.$http.get(`${config.apiUrl}/arena/table-model/list?includeDisabled=${true}`).then(response => {
          this.arenas = response.body
          this.isLogLoadInProgress = false
        }, error => {
          console.log(error)
          this.isLogLoadInProgress = false
        })
      }
    }
  }
</script>

<style scoped lang="scss" src="./ArenaStatusManagementPage.scss">

</style>
<style scoped lang="css" src="../../common-styles/smart-table.css">

</style>
